import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const RemoteContactsPane = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contacts_rail')
    .then((module) => ({ default: module.RemoteContactsPaneMFE }))
  ), null
)

export const RemoteContactsSearchHandler = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contacts_search_handler')
    .then((module) => ({ default: module.RemoteContactsSearchHandlerMFE }))
  ), null
)

export const RemoteFindOrCreateContactCard = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./find_or_create_contact_card')
    .then((module) => ({ default: module.RemoteFindOrCreateContactCardMFE }))
  ), null
)

export const ContactPage = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contact_page')
    .then((module) => ({ default: module.ContactPage }))
  ), null
)

export const ContactsSettingsPage = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contacts_settings_page')
    .then((module) => ({ default: module.ContactsSettingsPage }))
  ), null
)

export const CrmContainer = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contacts')
    .then((module) => ({ default: module.CrmContainerMFE }))
  ), null
)

export const RemoteContactCreateModal = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./create_contact_modal')
    .then((module) => ({ default: module.RemoteContactCreateModalMFE }))
  ), null
)

export const RemoteGoogleAccountSearchHandler = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./gmail_integration')
    .then((module) => ({ default: module.RemoteGoogleAccountSearchHandlerMFE }))
  ), null
)

export const RemoteGmailDisconnectButton = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./gmail_integration')
    .then((module) => ({ default: module.RemoteGmailDisconnectButtonMFE }))
  ), null
)

export const RemoteSyncReconnectButton = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./gmail_integration')
    .then((module) => ({ default: module.RemoteSyncReconnectButtonMFE }))
  ), null
)

export const RemoteContactCard = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./contact_card')
    .then((module) => ({ default: module.ContactCardMFE }))
  ), null
)

export const RemoteContactsModalsOutlet = withSafeSuspense(
  lazy(() => import(/* webpackChunkName: 'crm' */'./modals_outlet')
    .then((module) => ({ default: module.RemoteContactsModalsOutletMFE }))
  ), null
)
